import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import moment from 'moment';
import { EsquemaInversionService } from '../../../../services/esquema-inversion.service';
import { DatesHelpersService } from '../../../../services/tools/dates-helpers.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
declare var $;

@Component({
  selector: 'app-devoluciones-inversion-modal',
  templateUrl: './devoluciones-inversion-modal.component.html',
  styleUrls: ['./devoluciones-inversion-modal.component.scss']
})
export class DevolucionesInversionModalComponent implements OnInit {

  public isUpdate: boolean = false;
  public idRetiro: number = 0;
  public retiro_inversion : any = {};
  public inversion_fondeador : any = {};
  public errors:any = {};
  public processing: boolean = false;
  public fechaActual : string = "";
  public pago_con_formato: any;
  public pago_penalizacion: number = 0;
  public condonacion: number = 0;
  public penalizacion: number = 0;
  public band_penalizacion: boolean = false;
  public monto_final: number = 0;
  public monto_final_formato: any;
  //Intereses netos si es ahorrador
  public intereses_netos: number = 0;
  //Tipo de retiro
  public tipoRetiro: boolean = false;
  public retiroCapital: boolean = false;
  public retiroIntereses: boolean = false;
  //Capital
  public capital_disponible: number = 0;
  //Para inversionistas
  public monto_inversion: number = 0;

  constructor(
    private datesHelper : DatesHelpersService,
    private helperService: HelpersService,
    public inversionService: EsquemaInversionService,
    public dialogRef: MatDialogRef<DevolucionesInversionModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.retiro_inversion = this.inversionService.getDefaultScheduleDevolucion();

    let defaultDates = this.datesHelper.getMonthDate();
    this.fechaActual = defaultDates.fechaFin;

    this.retiro_inversion.idEsquemaInversion = this.data.inversiones.id;
    this.retiro_inversion.idFondeador = this.data.inversiones.idFondeador;

    this.inversion_fondeador = this.data.inversiones;
    console.log("Retiro: ", this.retiro_inversion);
    console.log("Data: ",this.inversion_fondeador);
    console.log("Total: ", this.data.total_inversion);
    
    if(this.data.editar != undefined){
      this.isUpdate = this.data.editar;
      console.log("Editar: ", this.isUpdate);
    }
    
    if(this.data.retiro_id != undefined){
      this.idRetiro = this.data.retiro_id;
      console.log("ID Retiro Modal: ", this.idRetiro);
      
    }

    if(this.inversion_fondeador.tipo_producto == "ahorrador"){
      this.intereses_netos = this.data.intereses;
      console.log("Interes netos: ", this.intereses_netos);
      this.capital_disponible = this.data.capital;
      console.log("Capital: ", this.capital_disponible);
    }else if(this.inversion_fondeador.tipo_producto == "inversionista"){
      this.monto_inversion = (this.data.total_inversion - this.data.intereses_desp_impuestos);
    }

    //Funciones a realizar si edita o no
    if(!this.isUpdate){
      this.retiro_inversion.fecha_devolucion_inversion = this.fechaActual;
    }else{
      this.obtenerRetiroPorID();
    }
  }

  quitarcondonacion(){
    // console.log("Monto general")
    // console.log(this.retiro_inversion.monto_retiro)
    let penalizacion = this.pago_penalizacion
    let condonacion = Number (this.condonacion)
    if (condonacion>100){condonacion = 100; this.condonacion = 100}if (condonacion<0){condonacion = 0; this.condonacion=0}
    condonacion = penalizacion * (condonacion/100)
    condonacion = Math.round((condonacion + Number.EPSILON) * 100)/100;
    console.log("SE va a condenar")
    console.log(condonacion)
    // this.condonacion = condonacion
    // Se obtiene el monto final a devolver al saldo a la vista
    let pago_penalizado = (penalizacion - condonacion);
    pago_penalizado = Math.round((pago_penalizado + Number.EPSILON) * 100)/100;
    this.pago_con_formato = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(pago_penalizado);

    let total = (this.retiro_inversion.monto_retiro - penalizacion + condonacion);
    this.monto_final = Math.round((total + Number.EPSILON) * 100)/100;
    this.monto_final_formato = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(this.monto_final);

    //Asignamos al json
    this.retiro_inversion.condonacion = condonacion;
    
  }

  //Obtener retiro por ID
  public obtenerRetiroPorID(){
    this.inversionService.getRetiroPorID(this.idRetiro)
     .subscribe((response) => {
       const datosRetiroUnico = response.json();

       console.log("Resp service retiro: ",datosRetiroUnico);

       if (datosRetiroUnico.success) {
        this.retiro_inversion = datosRetiroUnico.content;
        this.retiro_inversion.monto_retiro_anterior = this.retiro_inversion.monto_retiro;
        this.retiro_inversion.monto_penalizacion_anterior = this.retiro_inversion.pago_penalizacion;
        this.getTipoRetiro();
        if(this.retiro_inversion.tipo_retiro == 'capital'){
          this.capital_disponible = this.capital_disponible + this.retiro_inversion.monto_retiro_anterior;
        }else if(this.retiro_inversion.tipo_retiro == 'intereses'){
          this.intereses_netos = this.intereses_netos + this.retiro_inversion.monto_retiro_anterior;
        }
        console.log("Retiro Unico: ", this.retiro_inversion);
         
       }
     }, (error) => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
  }

  public close(){
    this.dialogRef.close({devolucion:false})
  }

  public accept(){
    //Validar
    this.errors = this.inversionService.validateDevolucion(this.retiro_inversion);
   
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    
    if(this.band_penalizacion){
      this.retirarFondosInversion();
    }else{
      alert("Da click en calcular penalización para poder registrar el retiro.")
    }
  }

  public retirarFondosInversion(){
    console.log("Datos finales de devolución: ", this.retiro_inversion);
    this.inversionService.devolucionEnInversion(this.retiro_inversion)
     .subscribe(response => {
       const datosRetiro = response.json();

       this.processing = false;
       if (datosRetiro.success) {
         this.helperService.notification('Devolución registrada', 'Se ha hecho exitosamente el retiro de fondos', 'success');
         this.dialogRef.close({ devolucion: true, datosRetiro: this.retiro_inversion });
         //setTimeout(() => {window.location.reload()},3000);
         
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
         this.close();
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
         this.close();
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
  }

  public actualizar(){
    //Validar
    this.errors = this.inversionService.validateDevolucion(this.retiro_inversion);
   
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    
    if(this.band_penalizacion){
      this.actualizarRetiro();
    }else{
      alert("Da click en calcular penalización para poder editar el retiro.")
    }
  }

  public actualizarRetiro(){
    this.inversionService.updateRetiro(this.retiro_inversion, this.idRetiro)
     .subscribe(response => {
       const datosRetiro = response.json();
       if (datosRetiro.success) {
         this.helperService.notification('Retiro actualizado', 'Se ha actualizado exitosamente el retiro de inversión seleccionado', 'success');
         this.dialogRef.close({devolucion: true, datosRetiro: this.retiro_inversion});
         //setTimeout(() => {window.location.reload()},3000);
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
  }

  public validarMonto(){
    if(this.inversion_fondeador.tipo_producto == "ahorrador"){
      if(this.retiroCapital){
        if(this.retiro_inversion.monto_retiro > this.capital_disponible){
          alert("No puede retirar una cantidad mayor al capital disponible.");
          this.retiro_inversion.monto_retiro = this.capital_disponible;
        }
      }else if(this.retiroIntereses){
        if(this.retiro_inversion.monto_retiro > this.intereses_netos){
          alert("No puede retirar una cantidad mayor a los intereses generados.");
          this.retiro_inversion.monto_retiro = this.intereses_netos;
        }
      }
    }else if(this.inversion_fondeador.tipo_producto == "inversionista"){
      if(this.retiroCapital){
        if(this.retiro_inversion.monto_retiro > this.monto_inversion){
          alert("No puede retirar una cantidad mayor al capital disponible.");
          this.retiro_inversion.monto_retiro = this.monto_inversion;
        }
      }
    }
  }

  public calcularPenalizacion(){
    this.band_penalizacion = true;
    //Validar
    this.errors = this.inversionService.validateDevolucion(this.retiro_inversion);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    let penalizacion_diaria = ((this.inversion_fondeador.penalizacion/100)/360);
    //console.log("Penalziacion diaria: ", penalizacion_diaria);
    //Obtenemos diferencia de días de fecha-inicio a fecha-termino
    let fecha_devolucion = new Date(this.retiro_inversion.fecha_devolucion_inversion).getTime();
    let fecha_fin = new Date(this.inversion_fondeador.fecha_fin_inversion).getTime();

    let diferencia = fecha_fin - fecha_devolucion;
    let dias_faltantes = Math.round(diferencia/(1000*60*60*24));
    //console.log("Días faltantes: ", dias_faltantes);
    
    let pago_penalizado = ((penalizacion_diaria*dias_faltantes)*this.retiro_inversion.monto_retiro);
    //console.log("% * Dias faltantes: ", (penalizacion_diaria*dias_faltantes));
    //console.log("Monto sin formato: ",pago_penalizado);
    this.pago_penalizacion = Math.round((pago_penalizado + Number.EPSILON) * 100)/100;
    this.pago_con_formato = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(this.pago_penalizacion);
    //console.log("Monto a penalizar: ",this.pago_penalizacion);
    let total = (this.retiro_inversion.monto_retiro - pago_penalizado);
    //Se obtiene el monto final a devolver al saldo a la vista
    this.monto_final = Math.round((total + Number.EPSILON) * 100)/100;
    this.monto_final_formato = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(this.monto_final);
    //Asignamos al json
    this.retiro_inversion.pago_penalizacion = this.monto_final;
    this.retiro_inversion.monto_retiro = Number(this.retiro_inversion.monto_retiro);
  }

  public getTipoRetiro(){
    this.tipoRetiro = true;
    if(this.retiro_inversion.tipo_retiro == 'capital'){
      this.retiroCapital = true;
      //Validar
      if(this.inversion_fondeador.tipo_producto == "ahorrador"){
        this.retiro_inversion.monto_retiro = this.capital_disponible;
      }else if(this.inversion_fondeador.tipo_producto == "inversionista"){
        this.retiro_inversion.monto_retiro = this.monto_inversion;
      }
      this.retiroIntereses = false;
    }else if(this.retiro_inversion.tipo_retiro == 'intereses'){
      this.retiroIntereses = true;
      this.retiro_inversion.monto_retiro = this.intereses_netos;
      this.retiroCapital = false;
    }else if(this.retiro_inversion.tipo_retiro == ''){
      this.tipoRetiro = false;
      this.retiroCapital = false;
      this.retiroIntereses = false;
    }
    
  }

  public cerrar(){
    this.band_penalizacion = false;
  }
  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/devoluciones-inversion-modal/devoluciones-inversion-modal.component.ts